//
// ────────────────────────────────────────────────────────────────────────────────────────────────────────── I ──────────
//   :::::: S Y N C   A N D   A S Y N C   S E L E C T O R   C O M P O N E N T : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────────────────────────────────────────────────────────
//

import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import React from 'react';
import CreatableView from './CreatableView';
import SelectableView from './SelectableView';
import { EDULAI_PURPLE } from '../../../../styles/styleConsts';

const styles = {
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5
  },
  titleText: {
    margin: 0,
    marginRight: 5,
    fontSize: 15,
    letterSpacing: 1
  },
  subtitleText: {
    margin: 0,
    marginRight: 5,
    fontSize: 15,
    letterSpacing: 1,
    fontWeight: 'normal'
  },
  subtitleContainer: {
    marginBottom: 10
  }
};

class SelectableField extends React.Component {
  onHandleChange(value) {
    const { onSelect, input } = this.props;

    if (input) {
      // Force setTimeout to ensure the change is registered
      setTimeout(() => {
        input.onChange(value);
      }, 0);
    }
    if (onSelect) {
      onSelect(value);
    }
  }

  onInputChange(value) {
    const { onInputChange } = this.props;
    if (onInputChange) {
      onInputChange(value);
    }
  }

  render() {
    const {
      input,
      meta,
      title,
      multi,
      mandatory,
      classes,
      canCreate,
      onNewOption,
      onLoadOptions,
      subtitle,
      titleStyle,
      titleContainerStyle,
      containerstyle,
      bgColor,
      subTitleStyle,
      defaultValue
    } = this.props;
    const hasError = meta.touched && meta.error;
    let { value } = input;
    if (multi) {
      if (!_.isArray(input.value)) {
        value = [input.value];
      }
    } else if (_.isArray(input.value) && input.value.length) {
      value = _.first(input.value);
    }

    if (!value && defaultValue) {
      this.onHandleChange(defaultValue);
    }

    return (
      <div style={{ zIndex: 1250, ...containerstyle }}>
        {title && (
          <div className={classes.titleContainer} style={{ ...titleContainerStyle }}>
            <h4 className={classes.titleText} style={{ color: EDULAI_PURPLE, ...titleStyle }}>
              {title}
            </h4>
            {mandatory && <h5 style={{ color: 'red', margin: 10, marginLeft: 0 }}>*</h5>}
          </div>
        )}
        {subtitle && (
          <div className={classes.subtitleContainer}>
            <h4 className={classes.subtitleText} style={{ ...subTitleStyle, color: '#3f3f3f' }}>
              {subtitle}
            </h4>
          </div>
        )}
        {canCreate ? (
          <CreatableView
            value={value}
            onHandleChange={(tag) => this.onHandleChange(tag)}
            onLoadOptions={onLoadOptions ? (text) => onLoadOptions(text) : null}
            onNewOption={(optionName) => onNewOption(optionName)}
            hasError={hasError}
            bgColor="white"
            {...this.props}
          />
        ) : (
          <SelectableView
            value={value}
            onHandleChange={(tag) => this.onHandleChange(tag)}
            onLoadOptions={onLoadOptions ? (text) => onLoadOptions(text) : null}
            hasError={hasError}
            bgColor={bgColor}
            style={{ backgroundColor: 'white' }}
            {...this.props}
          />
        )}
        {hasError && <h6 style={{ color: 'red', marginTop: 4, marginBottom: 0, marginLeft: 10 }}>{meta.error}</h6>}
      </div>
    );
  }
}

export default withStyles(styles)(SelectableField);
